// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7aa27dff","977":"847d8ede"}[chunkId] + ".chunk.js";
};